module.exports = __webpack_public_path__ + "media/images/pages/isaac/isaac-Image-d4a549f61db6ef3a036cabb0dd4a1a3e.jpg";